module.exports = __webpack_public_path__ + "static/media/gcdef_10026.47d13efe.ico";